import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { TIME } from '@swf/poker';

import { usePokerSpinAndGoWidget } from '../../../model';

export const TICKER_DURATION = TIME.SECOND * 10;
export const TICKER_DELAY_DURATION = TIME.SECOND * 2;

export const useTicker = () => {
  const { widgetSelect, widgetDispatch } = usePokerSpinAndGoWidget();
  const tickerMessage = useSelector(widgetSelect.tickerMessage);
  const showTickerTimerRef = useRef<NodeJS.Timeout>(undefined);

  useEffect(() => {
    if (tickerMessage) {
      showTickerTimerRef.current = setTimeout(() => {
        widgetDispatch.clearWatchGamesTicker();
      }, TICKER_DURATION + TICKER_DELAY_DURATION);
    }

    return () => clearTimeout(showTickerTimerRef?.current);
  }, [tickerMessage, widgetDispatch]);

  useEffect(() => {
    const recentBigWinsTimer = setTimeout(() => {
      widgetDispatch.setRandomRBWTicker();
    }, TIME.SECOND * 10);
    return () => clearTimeout(recentBigWinsTimer);
  }, [widgetDispatch]);

  return tickerMessage;
};
